import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { IconButton } from "..";
import classes from "./TopNav.module.scss";

export const TopNav = ({
  offset,
  backButton,
  backButtonUrl,
  title,
  rightSection,
}) => {
  const navigate = useNavigate();
  return (
    <nav className={`${classes["top-nav"]} ${offset ? classes["offset"] : ""}`}>
      <div className="d-flex align-items-center">
        {backButton && (
          <IconButton
            data-testid={"back-button"}
            className={`${classes["back-button"]} icon-chevron-left`}
            onClick={() => {
              backButtonUrl ? navigate(backButtonUrl) : navigate(-1);
            }}
          />
        )}
        <div className={`${classes["nav-title"]}`}>{title}</div>
      </div>
      <div>{rightSection}</div>
    </nav>
  );
};

TopNav.propTypes = {
  /**
   * set true for extra offset on the left
   */
  offset: PropTypes.bool,
  /**
   * set true to have a back button
   */
  backButton: PropTypes.bool,
  /**
   * title to be shown on the navbar
   */
  title: PropTypes.any,
};

TopNav.defaultProps = {
  offset: false,
  backButton: false,
  title: "",
};
